import { render } from "./DamagedParts.vue?vue&type=template&id=259a7497"
import script from "./DamagedParts.vue?vue&type=script&lang=js"
export * from "./DamagedParts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__